export default __webpack_public_path__ + "static/tailwind-ecea05a0fe316c3779cd11f30bd9dce7.svg";